import { render, staticRenderFns } from "./hbfx1.vue?vue&type=template&id=97716c82"
import script from "./hbfx1.vue?vue&type=script&lang=js"
export * from "./hbfx1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports